// Trading API — authenticatedFetch 래퍼 (services/tradingApi.js 대체)
export { authenticatedFetch as tradingFetch } from '../../utils/auth';

export const TRADING_TABS = [
  { id: 'intro', label: '📖 소개' },
  { id: 'trade', label: '📈 주문' },
  { id: 'portfolio', label: '💼 포트폴리오' },
  { id: 'balance', label: '💰 잔고' },
  { id: 'history', label: '📋 주문내역' },
  { id: 'ai-trade', label: '🤖 AI거래설정' },
  { id: 'notification', label: '🔔 알림설정' },
];

// 디바운스 유틸리티 함수
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// 가격 변동 포맷 함수 (변동금액(변동률%) 형식)
export const formatChange = (stockData) => {
  console.log('🔍 formatChange 호출:', {
    change: stockData.change,
    changeRate: stockData.changeRate,
    price: stockData.price,
    hasChange: stockData.change !== undefined && stockData.change !== null
  });
  
  let change = stockData.change; // 전일대비 (원 단위)
  let changeRate = stockData.changeRate || 0; // 전일대비율 (%)
  
  // change가 없으면 changeRate로부터 계산 시도
  if (change === undefined || change === null) {
    if (stockData.price > 0 && Math.abs(changeRate) <= 100) {
      // changeRate가 정상 범위면 price로부터 change 계산
      const prevClose = stockData.price / (1 + changeRate / 100);
      change = stockData.price - prevClose;
      console.log('📊 change 값 계산:', { change, changeRate, price: stockData.price, prevClose });
    } else {
      change = 0;
    }
  }
  
  // 변동률이 비정상 범위면 클라이언트에서도 보정 시도
  if (Math.abs(changeRate) > 100 && change !== 0 && stockData.price > 0) {
    console.warn('⚠️ 클라이언트: 비정상 변동률 감지, 보정 시도:', {
      original: changeRate,
      change,
      price: stockData.price
    });
    
    // 소수점 누락 가능성 체크
    if (Math.abs(changeRate) < 100000) {
      const possibleCorrectRate = changeRate / 100;
      if (Math.abs(possibleCorrectRate) <= 100) {
        const prevClose = stockData.price - change;
        if (prevClose > 0) {
          const expectedRate = (change / prevClose) * 100;
          if (Math.abs(possibleCorrectRate - expectedRate) < 10) {
            changeRate = possibleCorrectRate;
            console.log('✅ 클라이언트: 변동률 보정 성공:', changeRate);
          }
        }
      }
    }
    
    // 보정 실패 시 change와 price로 직접 계산
    if (Math.abs(changeRate) > 100 && change !== 0 && stockData.price > 0) {
      const prevClose = stockData.price - change;
      if (prevClose > 0) {
        changeRate = (change / prevClose) * 100;
        console.log('✅ 클라이언트: 변동률 직접 계산:', {
          original: stockData.changeRate,
          corrected: changeRate,
          change,
          price: stockData.price,
          prevClose
        });
      }
    }
  }
  
  // 최종 안전장치: 변동률이 여전히 비정상 범위면 강제 보정
  if (Math.abs(changeRate) > 100) {
    if (change !== 0 && stockData.price > 0) {
      const prevClose = stockData.price - change;
      if (prevClose > 0) {
        changeRate = (change / prevClose) * 100;
        console.warn('⚠️ 클라이언트: 변동률 강제 보정 (change 사용):', changeRate);
      }
    } else if (stockData.price > 0) {
      // change가 없으면 소수점 누락 가능성 체크
      if (Math.abs(changeRate) < 100000) {
        const possibleCorrectRate = changeRate / 100;
        if (Math.abs(possibleCorrectRate) <= 100) {
          changeRate = possibleCorrectRate;
          console.warn('⚠️ 클라이언트: 변동률 강제 보정 (소수점 누락):', changeRate);
        }
      }
    }
  }
  
  // change가 없으면 changeRate로부터 계산 시도
  if ((change === undefined || change === null) && stockData.price > 0 && Math.abs(changeRate) <= 100) {
    const prevClose = stockData.price / (1 + changeRate / 100);
    change = stockData.price - prevClose;
    console.log('📊 change 값 계산:', { change, changeRate, price: stockData.price, prevClose });
  }
  
  // 변동금액 포맷 (정수로 표시)
  // change가 없거나 0이면 변동률만 표시
  let changeFormatted;
  if (change === undefined || change === null || change === 0) {
    // change가 없으면 변동률만 표시
    changeFormatted = '0';
  } else {
    // 정수로 포맷 (소수점 제거)
    const changeInt = Math.round(change);
    changeFormatted = changeInt >= 0 
      ? `+${changeInt.toLocaleString()}` 
      : `${changeInt.toLocaleString()}`;
  }
  
  // 변동률 포맷 (소수점 2자리)
  const changeRateFormatted = changeRate >= 0
    ? `+${changeRate.toFixed(2)}`
    : changeRate.toFixed(2);
  
  // change가 없거나 0이면 변동률만 표시
  if (change === undefined || change === null || change === 0) {
    return `${changeRateFormatted}%`;
  }
  
  // "-5800.00( 5.77%)" 형식으로 반환 (변동 단어 제거, 변동률 부호 제거)
  // 변동률의 부호 제거 (변동금액의 부호로 방향 표시)
  const changeRateFormattedNoSign = changeRateFormatted.replace(/^[+-]/, '');
  return `${changeFormatted}( ${changeRateFormattedNoSign}%)`;
};

